import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";

export function getAirlines(type = null) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    let url = process.env.ROOT_API + 'admin/airlines';
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Airline List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getAirline(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/airline?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Arilone");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteAirlone(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.delete(process.env.ROOT_API + 'admin/airline?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Delete Airline");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateAirline(airline) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/airline', JSON.stringify(airline), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Airline Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getMawbs(airlineId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/airline/mawbs/available?airlineId=' + airlineId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Get available MAWBs");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function addMawbs(airlineId, from, to) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/airline/register/mawbs?airlineId=' + airlineId + '&from='+from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Add new MAWBs");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function createNewAirline() {
  let item = {
    id:0,
    title:'',
    description:'',
    address1:'',
    address2:'',
    address3:'',
    postCode:'',
    country:'',
    email:'',
    telephone:'',
    fax:'',
    edit:true,
    flightNamePrefix:'',
    airlineCode:'',
    account:'',
    airportDeparture:'HEATHROW',
    airportDestination:'INCHEON',
    toCode:'ICN',
    isDefault:false,
  }
  return item;
}



// WEBPACK FOOTER //
// ./src/api/airlines.js